import React from 'react'
import * as ReactIcons from '@src/lib/react-icons'
import Pagination from '@src/components/pagination'
import './style.scss'
import { map, includes } from '@src/lib/lodash'
import classNames from 'classnames'
import { fieldParse } from '@src/utils'

const stateMap: { [status: string]: { description: string, style: string } } = {
  1: { description: '使用中', style: 'state-use'},
  0: { description: '停用', style: 'state-stop'}
}

interface TableProps {
  header: string[];
  fieldOrder: string[];
  data: any;
  editOnClick?: (rowData: any) => void; 
  delOnClick?: (rowData: any) => void;
  viewOnClick?: (rowData: any) => void;
  totalNumber: number;
  totalPages: number;
  currentPage: number;
  prevOnClick: () => void
  nextOnClick: () => void
  moveToOnClick: (pageNumber: number) => void
}

const Table: React.FC<TableProps> = ({
  header,
  data,
  fieldOrder,
  totalNumber,
  totalPages,
  currentPage,
  prevOnClick,
  nextOnClick,
  moveToOnClick,
  editOnClick,
  delOnClick,
  viewOnClick
}) => {
  const hasOperation = editOnClick || delOnClick || viewOnClick
  return (
    <div className='table'>
      <div className='table-wrap'>
        <table className='table-content'>
          <thead>
            <tr>
              {map(header, (fieldName, fieldIndex) => (
                <th key={fieldIndex}>{fieldName}</th>
              ))}
              {hasOperation && <th>操作</th>}
            </tr>
          </thead>
          <tbody>
            {map(data, (rowData: any, rowIndex) => (
              <tr key={rowIndex}>
                {map(fieldOrder, (fieldName, index) => {
                  const fieldValue = rowData[fieldName]
                  return (
                    <td key={index}>
                      {
                        fieldName === 'status'
                          ? <span className={classNames('state', stateMap?.[fieldValue]?.style )}>
                            {stateMap?.[fieldValue]?.description}
                          </span>
                          : includes(['createdAt', 'updatedAt', 'time'], fieldName)
                            ? fieldParse(fieldValue)
                            : fieldValue
                      }
                    </td>
                  )
                })}
                {
                  hasOperation && <td>
                    <div className='operate-column'>
                      {
                        viewOnClick && <button className='operate-btn' aria-label='View' onClick={() => viewOnClick(rowData)}>
                          <ReactIcons.MdAssignment />
                        </button>
                      }
                      {
                        editOnClick && <button className='operate-btn' aria-label='Edit' onClick={() => editOnClick(rowData)}>
                          <ReactIcons.MdEdit />
                        </button>
                      }
                      {
                        delOnClick && <button className='operate-btn' aria-label='Delete' onClick={() => delOnClick(rowData)}>
                          <ReactIcons.MdDelete />
                        </button>
                      }
                    </div>
                  </td>
                }
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className='table-footer'>
        <Pagination
          totalNumber={totalNumber}
          totalPages={totalPages}
          currentPage={currentPage}
          prevOnClick={prevOnClick}
          nextOnClick={nextOnClick}
          moveToOnClick={moveToOnClick}
        />
      </div>
    </div>
  );
};

export default Table;
